module.exports = __webpack_public_path__ + "static/media/BlackCross.24fdb336.svg";